export enum ExportTypes {
    XLSX = "xlsx",
    CSV = "csv",
}

export type CommonExportReq = {
    format: ExportTypes;
    ids: string[];
};
